function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L45 0L45 45L0 45L0 0Z",
  id: "python_path_1"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "python_mask_1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#python_path_1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "python-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L45 0L45 45L0 45L0 0Z",
  id: "python-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#python_mask_1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.0293 21.1816L29.9707 21.1816C31.1823 21.1816 32.168 20.196 32.168 18.9844L32.168 6.5918C32.168 2.95704 29.2109 0 25.5762 0L19.4238 0C15.7891 0 12.832 2.95704 12.832 6.5918L12.832 10.1953L22.5 10.1953C23.2282 10.1953 23.8184 10.7855 23.8184 11.5137C23.8184 12.2419 23.2282 12.832 22.5 12.832L6.5918 12.832C2.95704 12.832 0 15.7891 0 19.4238L0 25.5762C0 29.2109 2.95704 32.168 6.5918 32.168L10.1953 32.168L10.1953 26.0156C10.1953 23.3501 12.3637 21.1816 15.0293 21.1816ZM18.1055 5.36133C18.1055 4.63314 18.6956 4.04297 19.4238 4.04297C20.152 4.04297 20.7422 4.63314 20.7422 5.36133C20.7422 6.08952 20.152 6.67969 19.4238 6.67969C18.6956 6.67969 18.1055 6.08952 18.1055 5.36133Z",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.9727 0L21.9727 6.15234C21.9727 8.8179 19.8042 10.9863 17.1387 10.9863L2.19727 10.9863C0.98568 10.9863 0 11.972 0 13.1836L0 25.5762C0 29.2109 2.95704 32.168 6.5918 32.168L12.7441 32.168C16.3789 32.168 19.3359 29.2109 19.3359 25.5762L19.3359 21.9727L9.66797 21.9727C8.93978 21.9727 8.34961 21.3825 8.34961 20.6543C8.34961 19.9261 8.93978 19.3359 9.66797 19.3359L25.5762 19.3359C29.2109 19.3359 32.168 16.3789 32.168 12.7441L32.168 6.5918C32.168 2.95704 29.2109 0 25.5762 0L21.9727 0ZM14.0625 26.8066C14.0625 27.5348 13.4723 28.125 12.7441 28.125C12.016 28.125 11.4258 27.5348 11.4258 26.8066C11.4258 26.0785 12.016 25.4883 12.7441 25.4883C13.4723 25.4883 14.0625 26.0785 14.0625 26.8066Z",
  transform: "translate(12.832031 12.832031)",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
})));

var SvgPython = function SvgPython(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPython, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/python.73e333b4.svg";
export { ForwardRef as ReactComponent };